import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import BeatLoader from 'react-spinners/BeatLoader';

function StockTable({ stockData, onReturn,onEdit }) {
  const formatStockQty = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return value;
    return numeric.toFixed(2);
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table aria-label="stock table">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold' }}>Item Name</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Stock Quantity</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Last Stock In Date</TableCell>
           
          </TableRow>
        </TableHead>
        <TableBody>
          {stockData.length > 0 ? (
            stockData.map((row) => {
              const lastStockInDate =
                row.lastStockInDate ||
                row.laststockindate ||
                row.latestgrndate ||
                row.stockindate ||
                '-';

              return (
                <TableRow key={row.stockId}>
                  <TableCell>{row.itemname}</TableCell>
                  <TableCell>{formatStockQty(row.stock)}</TableCell>
                  <TableCell>{lastStockInDate}</TableCell>
               
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={onReturn ? 6 : 5} align="center">
                <center><BeatLoader color="#000000" /></center>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {/** Optionally, display a message when there's no data */}
                  {/** If you're using loading state elsewhere, adjust accordingly */}
                  No stock data available.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default StockTable;
